import { render, staticRenderFns } from "./ArtisanGridItem.vue?vue&type=template&id=ec8ff954"
import script from "./ArtisanGridItem.vue?vue&type=script&lang=js"
export * from "./ArtisanGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports